import useTranslate from 'hooks/useTranslate';
import React, { useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

interface SaveTalentBtnProps {
	isFavourite: boolean;
	handleClick: any;
	className: string;
}

const SaveTalentBtn: React.FC<SaveTalentBtnProps> = ({
	isFavourite,
	handleClick = () => null,
	className = 'filled-btn fav-btn rounded-pill lh-1',
}) => {
	const { translate } = useTranslate();
	const btnClass = !isFavourite
		? 'whishlist-btn bg-white rounded-circle p-0 btn btn-primary'
		: 'filled-btn fav-btn rounded-pill lh-1';
	const [tooltipText, setTooltipText] = useState(translate('Extras.saveTalent'));

	const handleMouseEnter = () => {
		setTooltipText(isFavourite ? translate('Company.savedTalent') : translate('Extras.saveTalent'));
	};

	const handleMouseLeave = () => {
		setTimeout(() => {
			setTooltipText(translate('Extras.saveTalent'));
		}, 500);
	};

	return (
		<OverlayTrigger
			placement="bottom"
			delay={{ show: 250, hide: 400 }}
			overlay={isMobile ? <></> : <Tooltip id="button-tooltip-2">{tooltipText}</Tooltip>}
		>
			<Button
				className={btnClass}
				onClick={handleClick}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				<i className={`ri-star-${isFavourite ? 'fill' : 'line'}`}></i>
			</Button>
		</OverlayTrigger>
	);
};

export default SaveTalentBtn;
